import { z } from 'zod'
import { addressSchema } from '@/shared/schemas/addressSchema'

export const LICENSE_TYPES = ['MONTHLY', 'ANNUAL'] as const

export const createBusinessSchema = z.object({
  legalName: z.string().trim().min(3, 'Mínimo 3 caracteres').max(80, 'Máximo 80 caracteres'),
  description: z.string().trim().max(500, 'Máximo 500 caracteres').optional().or(z.literal('')),
  logo: z.string().trim().max(500).optional().or(z.literal('')),
  businessCategoryIds: z.array(z.number().int().positive()).optional(),
  packageServiceIds: z
    .array(z.number().int().positive())
    .min(1, 'Selecciona al menos un servicio'),
  /** Si true, se usa la dirección de la organización y se oculta el paso Dirección. */
  useSameOrgAddress: z.boolean(),
  licenseType: z.enum(LICENSE_TYPES, { message: 'Selecciona el tipo de facturación' }),
  plannedDayToPay: z
    .number({ message: 'Indica un día válido' })
    .int()
    .min(1, 'Mínimo 1')
    .max(28, 'Máximo 28')
    .optional()
    .nullable(),
  address: addressSchema,
})

export type CreateBusinessFormValues = z.infer<typeof createBusinessSchema>
